import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductConditionLevel } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-condition-guide-modal',
  templateUrl: './condition-guide-modal.component.html',
  styleUrls: ['./condition-guide-modal.component.scss']
})
export class ConditionGuideModalComponent implements OnInit {
  public conditions: ProductConditionLevel;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { data: ProductConditionLevel }) {}

  ngOnInit() {
    this.conditions = this.data.data;
  }
}
